import React from "react"
import {repeatOutline, repeatSharp} from "ionicons/icons"

import TypeIcon from "./TypeIcon"

interface props {
    link?: string
    size?: "small" | "default" | "large"
    slot?: string
    text?: string
}

const IconDataSourceSync: React.FC<props> = ({ link, size, slot, text }) => {

    return <TypeIcon
        backgroundColor={'lightSteelBlue'}
        link={link}
        ios={repeatOutline}
        md={repeatSharp}
        size={size}
        slot={slot}
        text={text}
    />

}

export default IconDataSourceSync